import { useTranslation } from 'react-i18next';

import defaultStyles from '../../styles/index.module.css';

interface Props {
  message?: string;
}

const Loader: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div className={defaultStyles.Loading}>{t(message || 'Loading...')}</div>
  );
};

export default Loader;
